var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.card)?_c('Boolean',{attrs:{"value":_vm.isActive,"textOn":_vm.statusLabel,"textOff":_vm.statusLabel,"color":_vm.customColor}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }